/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import { useTheme } from '../../../utils/ThemeColorContext'
import { AppStyles } from '../../../assets/styles/AppStyles'
// import { conversionAPI } from '../../../redux/Actions/postMethods'

import CheckInformationWrapper from '../CheckInformationWrapper'
import DefaultPage from '../DefaultPage'
import Image1 from '../../../assets/images/Image.png'

const GenericReferred = () => {
  const { color, isSmallScreen } = useTheme()

  return (
    <DefaultPage>
      <div className="md:flex-col md:w-[456px] md:m-[auto] py-8 md:py-0 px-0 space-y-4 items-center">
        <div className="px-8">
          <CheckInformationWrapper img={Image1}>
            <div className="w-full space-y-8 md:space-y-10">
              <div className="flex flex-col items-center space-y-4 md:space-y-6 md:pb-[36px]">
                <h1
                  style={
                    isSmallScreen
                      ? {
                          ...AppStyles.Title1,
                          color: color.Plum,
                        }
                      : {
                          ...AppStyles.LargeTitle2,
                          color: color.Plum,
                        }
                  }
                  className="text-center"
                >
                  We’re{' '}
                  <span
                    style={
                      isSmallScreen
                        ? { ...AppStyles.Title1, color: color.Yellow }
                        : { ...AppStyles.LargeTitle2, color: color.Yellow }
                    }
                  >
                    Checking
                  </span>{' '}
                  Your Information Now!
                </h1>
                <p
                  style={
                    isSmallScreen
                      ? {
                          ...AppStyles.Body,
                          color: color.Grey,
                        }
                      : {
                          ...AppStyles.Body16,
                          color: color.Grey,
                        }
                  }
                  className="text-center"
                >
                  Our underwriting team are looking at your application now,
                  they'll reach out to you with anything they require or a
                  decision via email.
                </p>
              </div>
            </div>
          </CheckInformationWrapper>
        </div>
      </div>
    </DefaultPage>
  )
}
export default GenericReferred
